import { ApolloCache } from '@apollo/client/core';

// Mounted user lists refetch right away, all others on their next mount
export function invalidateUserList(cache: ApolloCache<unknown>) {
    cache.evict({ id: 'ROOT_QUERY', fieldName: 'usersWithLoginData' });
    cache.gc();
}
